<template>
  <v-file-input
    label="File input"
    dense
    outlined
    chips
    v-bind="{ ...$attrs, ...$props }"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
export default {
  name: 'BaseFileInput',
}
</script>
